import { format } from 'date-fns'
import { fr } from 'date-fns/locale'

const rapport = (data) => {
	const rapports = data.map(
		({
			id,
			modified,
			title: { rendered: title },
			acf: { fichier_a_telecharger: download, image: src },
		}) => {
			const modifiedDate = format(new Date(modified), 'EEEE dd MMMM yyyy', {
				locale: fr,
			})

			return {
				id,
				title,
				modifiedDate,
				download,
				src,
			}
		},
	)

	return rapports
}

export default rapport
